var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('icon',{class:_vm.icon.class,attrs:{"name":_vm.icon.name}}),_c('span',{staticClass:"ms-2"},[_vm._v(_vm._s(_vm.$t(_vm.icon.label)))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }